<h4 *ngIf="isBookingSummary" [innerHTML]="'booking.bookingSummary.courses' | translate"></h4>
<section class="background-color-darkorange error" *ngIf="showServerError$ | async">
    <div class="container">
        <span class="error-message" [innerHTML]="'courses.serverError' | translate"></span>
        <button class="drg-icon-close" (click)="closeError()"></button>
    </div>
</section>
<section *ngIf="events$ | async as events" class="first-section">
    <ng-container *ngIf="events.length > 0; else loader">
        <table class="items">
            <tr class="header" *ngIf="events.length > 0">
                <th></th>
                <th class="title" [innerHTML]="'booking.booking.title' | translate"></th>
                <th [innerHTML]="'booking.booking.type' | translate"></th>
                <th [innerHTML]="'booking.booking.date' | translate"></th>
                <th [innerHTML]="'common.location' | translate"></th>
                <th colspan="2" class="price" [innerHTML]="'booking.booking.price' | translate"></th>
            </tr>
            <ng-container *ngIf="isLoggedInUser$ | async">
                <tr
                    *ngFor="let event of events; let i = index"
                    id="row{{ i }}"
                    [ngClass]="showWarningTile && checkPrerequirements(event, i) && !isBookingSummary ? 'warning' : ''"
                >
                    <!-- <tr *ngFor="let event of events; let i = index"> -->

                    <td class="order-number">
                        <span>{{ i + 1 }}.</span>
                        <div class="warning" *ngIf="!isBookingSummary">
                            <div class="inner">
                                <p [innerHTML]="'booking.booking.warning' | translate"></p>
                                <a class="close" (click)="closeWarning(event.externalId, event.courseId, i)"></a>
                            </div>
                        </div>
                    </td>
                    <td class="title">
                        <span class="order-number">{{ i + 1 }}.</span>

                        <a *ngIf="event.courseUnicodeTitle && event.courseUnicodeTitle !== null && event.courseUnicodeTitle !== ''" class="title" [href]="getCourseDetailLink(event.courseId)">{{ event.courseUnicodeTitle }}</a>
                        <a *ngIf="!event.courseUnicodeTitle || event.courseUnicodeTitle === null || event.courseUnicodeTitle === ''" class="title" [href]="getCourseDetailLink(event.courseId)">{{ event.courseName }}</a>
                    </td>
                    <td class="type">
                        <span *ngIf="event.courseType === 'WBT' && !event.isWishItem" [innerHTML]="'courses.online' | translate"></span>
                        <span *ngIf="(event.courseType === 'SEM' || event.courseType === 'WRK') && !event.isWishItem" [innerHTML]="'courses.presence' | translate"></span>
                        <span *ngIf="event.courseType === 'WBN' && !event.isWishItem" [innerHTML]="'courses.virtual' | translate"></span>
                        <span *ngIf="event.isWishItem" [innerHTML]="'courses.wishlist' | translate"></span>
                    </td>

                    <td class="date">
                        <span [innerHTML]="'booking.checkoutList.date' | translate"></span>
                        {{ event.beginDateTime | date: (dateFormat$ | async) + ', ' + 'HH:mm' }}<span class="separator" *ngIf="event.beginDateTime"> -</span
                        ><br *ngIf="event.beginDateTime" />{{ event.endDateTime | date: (dateFormat$ | async) + ', ' + 'HH:mm' }}
                        <span *ngIf="!event.beginDateTime" class="line">-</span>
                    </td>
                    <td class="location">
                        <span [innerHTML]="'common.location' | translate"></span>
                        <span *ngIf="event.location">
                            <a class="city" (click)="openLocationOverlay(event)">{{ event.location.city }}</a>
                        </span>
                        <span *ngIf="!event.location" class="line">-</span>
                    </td>
                    <td class="price" *ngIf="!event.isWishItem">
                        <ng-container *ngIf="order$ | async as order">
                            <!--            <div class="inner-content" *ngIf="order$ | async as order">-->
                            <span [innerHTML]="'booking.checkoutList.lastPrice' | translate"></span>
                            <p>
                                <span [ngClass]="order && order.participants && order.participants.length === 1 ? 'hide' : ''">
                                    <i>{{ order.participants.length }} x </i>
                                </span>
                                    <da-checkout-list-event-price *ngIf="!(isLoggedInUser$ | async)" [price] = "event.externalPrice" [currency] = "currency"></da-checkout-list-event-price>
                                    <da-checkout-list-event-price *ngIf="(isLoggedInUser$ | async) && event.externalPrice !== null" [price] = "event.externalPrice" [currency] = "currency"></da-checkout-list-event-price>
                                    <da-checkout-list-event-price *ngIf="(isLoggedInUser$ | async) && event.externalPrice === null" [price] = "event.coursePrice" [currency] = "currency"></da-checkout-list-event-price>
                                
                            </p>
                        </ng-container>
                    </td>
                    <td class="price" *ngIf="event.isWishItem">
                        <ng-container *ngIf="order$ | async as order">
                            <p>
                                <span
                                    class="headline"
                                    [ngClass]="order && order.participants && order.participants.length === 1 ? 'hide' : ''"
                                >
                                    <i>{{ order.participants.length }} x </i> </span
                                ><span class="headline" [innerHTML]="'courses.prebooking' | translate"></span>
                            </p>
                        </ng-container>
                    </td>
                    <td class="delete">
                        <a href="" (click)="remove(i, $event)" class="link drg-icon-delete"></a>
                    </td>
                </tr>
            </ng-container>
            <ng-container *ngIf="!(isLoggedInUser$ | async)">
                <tr *ngFor="let event of events; let i = index">
                    <td class="order-number">
                        {{ i + 1 }}.
                        <div class="warning" *ngIf="!isBookingSummary">
                            <div class="inner">
                                <p [innerHTML]="'booking.booking.warning' | translate"></p>
                                <a class="close" href="javascript:;"></a>
                            </div>
                        </div>
                    </td>
                    <td class="title">
                        <span class="order-number">{{ i + 1 }}.</span>
                        <a *ngIf="event.courseUnicodeTitle && event.courseUnicodeTitle !== null && event.courseUnicodeTitle !== ''" class="title" [href]="getCourseDetailLink(event.courseId)">{{ event.courseUnicodeTitle }}</a>
                        <a *ngIf="!event.courseUnicodeTitle || event.courseUnicodeTitle === null || event.courseUnicodeTitle === ''" class="title" [href]="getCourseDetailLink(event.courseId)">{{ event.courseName }}</a>
                    </td>
                    <td class="type">
                        <span *ngIf="event.courseType === 'WBT' && !event.isWishItem" [innerHTML]="'courses.online' | translate"></span>
                        <span *ngIf="(event.courseType === 'SEM' || event.courseType === 'WRK') && !event.isWishItem" [innerHTML]="'courses.presence' | translate"></span>
                        <span *ngIf="event.courseType === 'WBN' && !event.isWishItem" [innerHTML]="'courses.virtual' | translate"></span>
                        <span *ngIf="event.isWishItem" [innerHTML]="'courses.wishlist' | translate"></span>
                    </td>

                    <td class="date">
                        <span [innerHTML]="'booking.checkoutList.date' | translate"></span>
                        {{ event.beginDateTime | date: (dateFormat$ | async) + ', ' + 'HH:mm' }}<span class="separator" *ngIf="event.beginDateTime"> -</span
                        ><br *ngIf="event.beginDateTime" />{{ event.endDateTime | date: (dateFormat$ | async) + ', ' + 'HH:mm' }}
                        <span *ngIf="!event.beginDateTime" class="line">-</span>
                    </td>
                    <td class="location">
                        <span [innerHTML]="'common.location' | translate"></span
                        ><span *ngIf="event.location">
                            <a class="city" (click)="openLocationOverlay(event)">{{ event.location.city }}</a>
                        </span>
                        <span *ngIf="!event.location" class="line">-</span>
                    </td>
                    <td class="price" *ngIf="!event.isWishItem">
                        <ng-container *ngIf="order$ | async as order">
                            <!--            <div class="inner-content" *ngIf="order$ | async as order">-->
                            <span [innerHTML]="'booking.checkoutList.lastPrice' | translate"></span>
                            <p>
                                <span [ngClass]="order && order.participants && order.participants.length === 1 ? 'hide' : ''">
                                    <i>{{ order.participants.length }} x </i>
                                </span>
                                    <da-checkout-list-event-price *ngIf="event.externalPrice" [price] = "event.externalPrice" [currency] = "currency"></da-checkout-list-event-price>
                                    <da-checkout-list-event-price *ngIf="!event.externalPrice" [price] = "event.coursePrice" [currency] = "currency"></da-checkout-list-event-price>


                            </p>
                            <!--            </div>-->

                            <!--          // todo: check if this is needed at all-->
                            <!--            <div class="desc">-->
                            <!--                {{ event.provider }}-->
                            <!--            </div>-->
                        </ng-container>
                    </td>
                    <td class="price" *ngIf="event.isWishItem">
                        <ng-container *ngIf="order$ | async as order">
                            <p>
                                <span
                                    class="headline"
                                    [ngClass]="order && order.participants && order.participants.length === 1 ? 'hide' : ''"
                                >
                                    <i>{{ order.participants.length }} x </i> </span
                                ><span class="headline" [innerHTML]="'courses.prebooking' | translate"></span>
                            </p>
                        </ng-container>
                    </td>
                    <td class="delete">
                        <a href="" (click)="remove(i, $event)" class="link drg-icon-delete"></a>
                    </td>
                </tr>
            </ng-container>
        </table>
    </ng-container>
    <section class="background-color-nearwhite bottom" *ngIf="isBookingSummary">
        <ng-container *ngIf="(isLoggedInUser$ | async) && (onlyWebinars$ | async) && (site === 'de_ch' || site === 'fr_ch' || site === 'ch-ext-md' || site === 'ch-ext-sd')">
            <da-coupon-code (voucherData)="findNewAmount($event)" [totalPrice]="totalPrice$ | async" [minusPrice]="minusPrice$ | async" [currency]="currency"></da-coupon-code>
        </ng-container>
        <div  *ngIf="!(onlyWishListItems$ | async)" class="bottom-wrapper">
            <table class="summary">
                <tr class="total">
                    <td><span [innerHTML]="'booking.booking.total' | translate"></span></td>
                    <td>
                        <span class="price">
                            <span>
                                <span> {{ formattedTotalPrice$ | async }}</span>
                                <span [innerHTML]="'booking.checkoutList.priceDesc' | translate"></span>
                            </span>
                        </span>
                    </td>
                </tr>
            </table>
        </div>
    </section>
    <!-- <section class="background-color-white bottom" *ngIf="!isBookingSummary && !(showServerError$ | async)"> -->
    <section class="background-color-white bottom" *ngIf="!isBookingSummary">
        <div>
            <ng-container *ngIf="order$ | async as order">
                <div class="participants" *ngIf="order && order.participants">
                    <p class="text" [innerHTML]="'booking.booking.info' | translate"></p>
                    <p>
                        <a
                            [ngClass]="order && order.participants && order.participants.length > 1 ? '' : 'disabled'"
                            class="decrease"
                            (click)="decreaseParticipants()"
                        ></a>
                        <span>{{ order.participants.length }}</span>
                    </p>

                    <a
                        class="increase"
                        [ngClass]="order && order.participants && order.participants.length === (maxSeats$ | async) ? 'disabled' : ''"
                        (click)="increaseParticipants()"
                    ></a>
                </div>
                <div
                    class="error"
                    *ngIf="order && order.participants && order.participants.length === (maxSeats$ | async)"
                    [innerHTML]="'booking.bookingParticipants.error' | translate"
                ></div>
            </ng-container>
            <div class="bottom-wrapper">
                <table class="summary">
                    <tr class="total" *ngIf="!(onlyWishListItems$ | async)">
                        <td><span [innerHTML]="'booking.booking.total' | translate"></span></td>
                        <td>
                            <span class="price">
                                <span class="totalPrice">{{ formattedTotalPrice$ | async }}</span>
                                <span [innerHTML]="'booking.checkoutList.priceDesc' | translate"></span>
                            </span>
                        </td>
                    </tr>
                   <tr *ngIf="!isBookingSummary && (onlyWebinars$ | async) && (isLoggedInUser$ | async) && (site === 'de_ch' || site === 'fr_ch' || site === 'ch-ext-md' || site === 'ch-ext-sd')">
                        <td class="voucher-info">
                            <p class="coupon-code-info" [innerHTML]="'couponCode.couponCodeInfo' | translate"></p>
                        </td>
                    </tr>
                    <tr class="button-wrapper" *ngIf="events$ | async as events">
                        <td class="back">
                            <a
                                da-link
                                [routerLink]="getCoursesLink()"
                                class="button secondary"
                                [innerHTML]="'booking.booking.backToCourses' | translate"
                            >
                            </a>
                        </td>
                        <td class="next">
                            <a
                                *ngIf="events.length > 0"
                                da-link
                                class="button primary"
                                (click)="nextClick()"
                                [innerHTML]="'booking.booking.toTheBooking' | translate"
                            ></a>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </section>
</section>

<ng-template #loader>
    <section>
        <div id="loader-screen" class="drg-loading-container">
            <i class="loading-icon"></i>
            <i class="loader-shadow"></i>
        </div>
    </section>
</ng-template>

<ng-template #overlay>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="warning"></ng-container>
    </div>
</ng-template>
<ng-template #warning>
    <div class="warn-popup">
        <div class="inner-wrapper">
            <div class="details" *ngIf="order$ | async as order">
                <h3 *ngIf="order.requestCreated" [innerHTML]="'booking.checkoutList.deleteCourseTitle' | translate"></h3>
                <h3 *ngIf="!order.requestCreated" [innerHTML]="'booking.checkoutList.emptyCartTitle' | translate"></h3>
                <p *ngIf="order.requestCreated" [innerHTML]="'booking.checkoutList.deleteCourseText' | translate"></p>
                <p *ngIf="!order.requestCreated" [innerHTML]="'booking.checkoutList.empyCart' | translate"></p>
                <div class="button-wrapper">
                    <a
                        (click)="cancleOrder()"
                        class="button secondary"
                        [innerHTML]="'booking.checkoutList.deleteCourseBtn' | translate"
                    ></a>
                    <a (click)="cancle()" class="button primary" [innerHTML]="'booking.checkoutList.cancleDeleteCourse' | translate"></a>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #locationOverlay>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="location"></ng-container>
    </div>
</ng-template>
<ng-template #location>
    <div class="location-popup" *ngIf="location$ | async as event">
        <div class="title">
            <span [innerHTML]="'common.location' | translate"></span>
        </div>
        <div class="details">
            <span><strong [innerHTML]="'common.address' | translate"></strong></span>
            <span>{{ event.location.name }}</span>
            <span>{{ event.location.street }}</span>
            <span>{{ event.location.city }} {{ event.location.zip }} </span>
            <span>{{ event.location.regionKey }}</span>
            <span>{{ countryName }} ({{ event.location.countryKey }})</span>
            <a
                *ngIf="event.location.isMapAvailable"
                target="_blank"
                [href]="envApi + 'api/v1/course/getlocationmap/' + event.location.locationSign"
                ><span [innerHTML]="'common.downloadRoute' | translate"></span
            ></a>
            <div><a class="button primary" [innerHTML]="'common.close' | translate" (click)="closeModal()"></a></div>
        </div>
    </div>
</ng-template>
